"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Radio extends _react.Component {
  componentDidMount() {
    this._input.addEventListener('invalid', this._onInvalid);
  }
  componentWillUnmount() {
    this._input.removeEventListener('invalid', this._onInvalid);
  }
  _onInvalid = evt => {
    evt.preventDefault();
    const {
      onValidationChange
    } = this.props;
    if (onValidationChange) {
      onValidationChange(evt.currentTarget.validity);
    }
  };
  _onChange = evt => {
    const {
      onValidationChange,
      onChange
    } = this.props;
    if (onValidationChange) {
      onValidationChange();
    }
    if (onChange) {
      onChange(evt);
    }
  };
  render() {
    const {
      label,
      className,
      name,
      value,
      defaultChecked,
      disabled,
      required,
      id
    } = this.props;
    const classes = (0, _classnames.default)('Radio', 'FormElement', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement("input", {
      ref: node => {
        this._input = node;
      },
      className: "FormElement-item",
      id: `Radio-${id}`,
      type: "radio",
      name: name,
      value: value,
      defaultChecked: defaultChecked,
      onChange: this._onChange,
      disabled: disabled,
      required: required
    }), /*#__PURE__*/(0, _react.cloneElement)(label, {
      htmlFor: `Radio-${id}`
    }));
  }
}
exports.default = Radio;